var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sag-modal"},[_c('b-modal',{ref:"modalRef",attrs:{"id":"smodal","title":"BootstrapVue"}},[_c('p',{staticClass:"my-4"},[_vm._v("Hello from modal!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }